exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-btns button:focus{\n  outline: none !important;\n}\n\n.noData img{\n  margin: auto;\n  max-width: 500px;\n}", ""]);

// exports
